import { colors } from '../../colors'

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger'
  size?: 'small' | 'medium' | 'large'
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  style?: React.CSSProperties
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  children,
  onClick,
  disabled = false,
  style = {},
}) => {
  const getVariantStyles = (): React.CSSProperties => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: colors['keijiban-coral'],
          color: colors['text-default'],
          border: `1px solid ${colors['keijiban-coral']}`,
        }
      case 'secondary':
        return {
          backgroundColor: colors.white,
          color: colors['text-secondary'],
          border: `1px solid ${colors['border-light']}`,
        }
      case 'danger':
        return {
          backgroundColor: 'transparent',
          color: colors['text-secondary'],
          border: 'none',
        }
      default:
        return {}
    }
  }

  const getSizeStyles = (): React.CSSProperties => {
    switch (size) {
      case 'small':
        return {
          padding: '4px 8px',
          fontSize: '12px',
        }
      case 'medium':
        return {
          padding: '8px 12px',
          fontSize: '14px',
        }
      case 'large':
        return {
          padding: '12px 16px',
          fontSize: '16px',
        }
      default:
        return {}
    }
  }

  const baseStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s ease',
    opacity: disabled ? 0.6 : 1,
    ...getVariantStyles(),
    ...getSizeStyles(),
    ...style,
  }

  return (
    <button style={baseStyles} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}

export default Button
